export type TEnvironment = 'test' | 'development' | 'preonline' | 'production' | 'unknown';

export const getNodeEnv = (): string => {
  if (typeof window !== 'undefined') return '';
  return process.env.NEXT_ENV || process.env.NODE_ENV || 'unknown';
};

export const getNodePlatform = (): string => {
  if (typeof window !== 'undefined') return '';
  return process.env.PLATFORM || '';
};

export const getBrowserEnv = (): TEnvironment => {
  if (typeof window === 'undefined') return 'unknown';
  const _host = window?.location.host;
  if (_host.indexOf('test') > -1 || _host.indexOf('staging') > -1) {
    return 'test';
  }

  if (_host.indexOf('pre') > -1) {
    return 'preonline';
  }

  if (_host.indexOf('localhost') > -1 || _host.indexOf('127.0.0.1') > -1) {
    return 'development';
  }

  return 'production';
};

export const getBrowserPlatform = () => {
  if (typeof window === 'undefined') return 'unknown';
  const _host = window?.location.host;
  if (_host.indexOf('xingye') > -1 || _host.indexOf('xingye') > -1) {
    return 'xingye';
  }

  if (_host.indexOf('talkie') > -1) {
    return 'talkie';
  }
  const _port = window?.location.port;

  if (_port.indexOf('3000') > -1) {
    return 'talkie';
  }

  if (_port.indexOf('3001') > -1) {
    return 'xingye';
  }

  return 'production';
};

export const isDev = getNodeEnv() === 'development' || getBrowserEnv() === 'development';
export const isTest = getNodeEnv() === 'test' || getBrowserEnv() === 'test';
export const isProd = getNodeEnv() === 'production' || getBrowserEnv() === 'production';

export const isBrowser = typeof window !== 'undefined';

export const isTalkie = getNodePlatform() === 'talkie' || getBrowserPlatform() === 'talkie';
